import { useTranslation } from 'react-i18next';

export default function ErrorFallback() {
  const { t } = useTranslation();
  
  return (
    <div className='container py-10 text-center'>
      <p>{t('errors.generic')}</p>
    </div>
  );
}
